// extracted by mini-css-extract-plugin
export default {"button":"ro-z","reviewSort":"so-z"};